export const defaultPageMetaData = {
  articleType: '',
  author: '',
  grunddata: false,
  bubble: false,
}

export const defaultNewsMetaData = {
  bubble: false,
}

export const defaultReportAvhandlingMetaData = {
  bubble: false,
}
